import styled from 'styled-components';
import { Color, MaxWidth } from '../common/base';

const AboutWrapper = styled.div`
  padding-top: 100px;
  ${MaxWidth.sm`
    padding: 60px 0;
  `}
  h1 {
    font-size: 48px;
    ${MaxWidth.sm`
      font-size: 32px;
    `}
  }
`;

const AboutTeamWrapper = styled.div`
  padding-top: 100px;
  position: relative;
  ${MaxWidth.sm`
    padding: 60px 0;
  `}
  &:before {
    content: '';
    position: absolute;
    background-color: ${Color.grey};
    width: 100%;
    top: 0;
    left: 0;
    height: calc(100% - 100px);
    ${MaxWidth.md`
      width: calc(100% + 32px);
      left: -16px;
      height: calc(100% + 80px);
    `}
  }
`;

export { AboutWrapper, AboutTeamWrapper };
